
<template>
	<div class="card-carousel" :class="{funnel, 'card-carousel-gradient': gradient, horizontal}">
		<div v-if="!horizontal" class="inside-wrapper">
			<div class="wrapper-content">
				<div class="wrapper-heading-card">
					<h4>{{ card.title }}</h4>
					<p>{{ card.description }}</p>
					<p class="subtitle">{{ card.subtitle }}</p>
				</div>
				<div class="wrapper-price">
					<p class="price-card">{{ formattedPlanPrice(month ? card?.monthPrice : card?.yearMonthPrice) }}</p>
					<p>{{currencyStore?.currCurrency?.symbol}}/{{ getString('month') }}</p>
				</div>
				<div @click="clickCta" class="button button-dark mb-10" :class="{'active-plan': userStore?.currBusiness?.active_plan === card.planId && userStore?.currBusiness?.plan_id}">
					<span v-if="!loading && !loadingPortal">{{ ctaText }}</span>
					<div v-if="loading || loadingPortal" class="col-12 centered p-12">
						<AppLoader :color="userStore?.currBusiness?.active_plan === card.planId ? '' : 'white'" :size="18" />
					</div>
				</div>
				<div class="wrapper-list" v-if="!funnel">
					<div v-for="(functionality, index) in card.functionalities" :key="index" class="item-list">
						<img v-if="functionality.available" src="https://img.qromo.io/img/web-site/new/icon-rounded-ok.svg" alt="check">
						<img v-else-if="functionality.available === false" src="https://img.qromo.io/img/web-site/new/icon-decline.svg" alt="check">
						<p :class="{highlight: functionality.highlight}" v-html="functionality.name"></p>
					</div>
				</div>
				<div class="wrapper-list funnel-wrapper-list" v-else-if="!!funnel && card.funnelFunctionalities">
					<div v-for="(functionality, index) in card.funnelFunctionalities" :key="index" class="item-list">
						<img v-if="functionality.available" src="https://img.qromo.io/img/web-site/new/icon-rounded-ok.svg" alt="check">
						<img v-else-if="functionality.available === false" src="https://img.qromo.io/img/web-site/new/icon-decline.svg" alt="check">
						<p :class="{highlight: functionality.highlight}" v-html="functionality.name"></p>
					</div>
				</div>
				<div @click="card.readMoreCallback" :class="{disabled: loading || loadingPortal}" class="button-read-more">
					<p>{{ getString(funnel ? 'compare_plans' : 'read_more') }}</p>
					<AppChevronIcon v-if="funnel" class="ml-10" direction="right" />
				</div>
			</div>
		</div>
		<div v-if="horizontal" class="inside-wrapper horizontal">
			<div class="wrapper-content">

				<div class="col-6">
					<div class="wrapper-heading-card">
						<h4>{{ card.title }}</h4>
						<p>{{ card.description }}</p>
						<p class="subtitle">{{ card.subtitle }}</p>
					</div>
				</div>
				<div class="col-6 centered align-end">
					<div @click="clickCta" class="button button-dark" :class="{'active-plan': userStore?.currBusiness?.active_plan === card.planId && sameCycle}">
						<span v-if="!loading && !loadingPortal">{{ ctaText }}</span>
						<div v-if="loading || loadingPortal" class="col-12 centered p-12">
							<AppLoader :color="userStore?.currBusiness?.active_plan === card.planId ? '' : 'white'" :size="18" />
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import AppLoader from "@/shared/components/AppLoader.vue";
import {useLanguageStore, useNotificationStore, useSvgStore, useCurrencyStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import API from "@/shared/helpers/API";

export default {
	components: {AppLoader, AppChevronIcon},
	emits: ["clicked-cta"],
	setup() {
		let svgStore = useSvgStore();
		let userStore = useUserStore();
		let languageStore = useLanguageStore();
		let notificationStore = useNotificationStore();
		let currencyStore = useCurrencyStore();
		return {getIcon: svgStore.get, currencyStore, userStore, getString: languageStore.getString, showNotification: notificationStore.showNotification}
	},
	name: "MarketplaceNewSubscriptionCard",
	data() {
		return {
			loadingPortal: false
		}
	},
	props: {
		card: {
			type: Object,
			validator: (value) => {
				let mandatoryProperties = ['planId', 'title', 'description', 'monthPrice', 'functionalities', 'readMoreCallback'];
				for(let prop of mandatoryProperties) {
					if(!value.hasOwnProperty(prop)) {
						return false;
					}
				}
				return true;
			},
		},
		horizontal: {
			type: Boolean,
			default: false
		},
		enterprise: {
			type: Boolean,
			default: false
		},
		gradient: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		funnel: {
			type: Boolean,
			default: false
		},
		month: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		ctaText() {
			if(this.userStore?.currBusiness?.plan_id) {
				if(this.userStore?.currBusiness?.active_plan === this.card.planId) {
					if(this.sameCycle) {
						return this.getString('my_costs');
					}
					return this.getString(this.month ? 'switch_to_monthly' : 'switch_to_yearly');
				} else if(this.userStore?.currBusiness?.active_plan && !this.enterprise) {
					return this.getString('switch_plan');
				}
			}
			if(this.horizontal && this.enterprise) {
				return this.getString('book_a_call');
			}
			return this.getString(this.trialAvailable ? 'start_now_free' : 'start_now');
		},
		sameCycle() {
			if(!this.userStore?.currBusiness || !this.userStore?.currBusiness?.plan_cycle) {
				return false;
			}
			return (this.userStore.currBusiness.plan_cycle === 'month' && this.month) || (this.userStore.currBusiness.plan_cycle === 'year' && !this.month);
		},
		trialAvailable() {
			return this.userStore.user && this.userStore.user.stripe_trial !== 1 && this.userStore.currBusiness && !this.userStore.currBusiness.stripe_trial;
		},
	},
	methods: {
		formattedPlanPrice(price) {
			if(typeof price === 'number') {
				return this.currencyStore.readableCurrencyValue(price, false, false, true);
			}
			return price || '';
		},
		clickCta() {
			if(this.loading || this.loadingPortal) {
				return
			}
			if(this.userStore?.currBusiness?.active_plan !== this.card.planId || !this.sameCycle) {
				this.$emit('clicked-cta');
			} else {
				this.clickGoToPortal();
			}
		},
		clickGoToPortal() {
			if(this.loading || this.loadingPortal) { return; }
			this.loadingPortal = true;
			API.init().getStripeCustomerPortal((r) => {
				if (r && typeof r === 'object' && r.url) {
					location.replace(r.url);
					setTimeout(() => {
						this.loadingPortal = false;
					}, 1000);
				} else {
					this.loadingPortal = false;
					this.showNotification('generic-fail');
				}
			});
		}
	}
}
</script>

<style scoped lang="scss">


.card-carousel {
	flex: 0 0 calc(33.33% - calc(20px / 3 * 2));
	max-width: calc(33.33% - calc(20px / 3 * 2));
	box-sizing: border-box;
	padding: 0 8px;
	z-index: 1;

	@media(max-width: 1260px) {
		flex: 0 0 calc(33.33% - calc(6px / 3 * 2));
		max-width: calc(33.33% - calc(6px / 3 * 2));
	}
	@media(max-width: 1180px) {
		flex: 0 0 calc(50% - 26px);
		max-width: calc(50% - 26px);
	}
	/*@media(max-width: 1080px) {
		flex: 0 0 calc(33.33% - calc(4px / 3 * 2));
		max-width: calc(33.33% - calc(4px / 3 * 2));
	}*/
	@include breakpoint(tablet) {
		flex: 0 0 100%;
		max-width: calc(100% - 40px);
		display: flex;
		justify-content: center;
	}
	@media(max-width: 520px) {
		padding: 0 6px;
	}
	@media (max-width: 450px) {
		max-width: calc(100% - 20px);
	}

	&:last-of-type {
		padding-right: 20px;
	}
	&:first-of-type {
		padding-left: 20px;
	}

	&.horizontal {
		min-height: unset;
		margin-bottom: 1px;
		padding-left: 20px;
	}
	.inside-wrapper {
		border-radius: 28px;
		width: calc(100% - 2px);
		height: calc(100% - 2px);
		position: relative;
		z-index: 1;
		&:before {
			content: '';
			position: absolute;
			top: -9px;
			left: -1px;
			width: calc(100% + 2px);
			height: calc(100% + 12px);
			//background: var(--prices-bg-dark);
			background: var(--color-primary);
			border-radius: 30px;
			filter: blur(0);
			opacity: 1;
			transition: all 0.3s ease;
			z-index: 0;
		}
		.wrapper-content {
			padding: 20px;
			display: flex;
			flex-direction: column;
			gap: 15px;
			z-index: 1;
			background-color: var(--color-bg-primary-1);
			border-radius: 29px;
			height: 100%;
			@media (max-width: 420px) or ((min-width: 1181px) and (max-width: 1400px)) {
				padding: 20px 10px;
			}
			.wrapper-heading-card {
				display: flex;
				flex-direction: column;
				gap: 5px;
				h4 {
					line-height: normal;
					font-size: 34px;
					font-weight: 600;
				}
				p {
					font-size: 16px;
					line-height: 20px;
					&.subtitle {
						font-size: 12px;
						line-height: 14px;
						color: var(--color-primary);
					}
				}
				@media(max-width: 420px) {
					p {
						font-size: 14px;
						line-height: 16px;
						/*&.subtitle {
							font-size: 12px;
							line-height: 14px;
						}*/
					}
				}
			}
			.button {
				background-color: var(--color-primary);
				color: var(--color-bg);
				border-radius: 13px;
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;

				&:hover {
					background-color: var(--prices-bg-primary-light);
				}
				span {
					@include truncateString;
					text-align: center;
					width: 100%;
					box-sizing: border-box;
					padding: 10px 0;
					max-height: 44px;
					cursor: pointer;
					font-size: 16px;
					font-weight: 500;
					border: none;
					transition: background-color 0.15s ease-in-out;
					color: var(--color-bg);
					&:after {
						display: none;
					}
				}
				&.active-plan {
					border: 2px solid var(--color-primary);
					background: none;
					span {
						background: none;
						color: var(--txt-0);
					}
				}
			}
			.button-read-more {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				margin-top: auto;
				cursor: pointer;
				p {
					font-size: 16px;
					line-height: 18px;
					color: var(--color-primary);
					font-weight: 500;
				}
			}
			.wrapper-list {
				border-top: 1px solid var(--color-fill-button);
				.item-list {
					display: flex;
					gap: 10px;
					min-height: 28px;
					align-items: center;
					border-bottom: 1px solid var(--color-fill-button);
					p {
						font-size: 16px;
						line-height: normal;
						color: var(--txt-1);

						&.highlight {
							color: var(--color-txt);
						}
					}
				}
				.wrapper-price {
					background-color: var(--color-bg);
					display: flex;
					justify-content: center;
					align-items: center;
					height: 50px;
					margin-top: -5px;
					p {
						font-size: 24px;
						line-height: 26px;
						color: var(--color-txt-white);
						margin: 0;
					}
				}
				&.funnel-wrapper-list .item-list p {
					font-size: 14px;
				}
			}
			.wrapper-price {
				display: flex;
				gap: 5px;
				align-items: flex-end;
				.price-card {
					font-size: 40px;
					line-height: normal;
					font-weight: 500;
				}
			}
		}
		&.horizontal {
			&:before {
				left: -9px;
				top: -1px;
				height: calc(100% + 2px);
				width: calc(100% + 10px);
			}
			.wrapper-content {
				flex-direction: row;

				@media (max-width: 768px) {
					flex-direction: column;

					.col-6 {
						max-width: 100%;

						&:first-child {
							margin-bottom: 10px;
						}

						.button {
							max-width: unset;
						}
					}
				}
			}
		}
	}
	&:not(.horizontal) {
		.inside-wrapper .wrapper-content .wrapper-heading-card {
			min-height: 150px;
		}
	}
	&.active .inside-wrapper {
		&:before {
			height: calc(100% + 14px);
			top: -13px;
		}
		.wrapper-content {
			background: var(--prices-bg-light-hover);
		}
	}
	&:hover {
		.inside-wrapper {
			&:before {
				filter: blur(10px);
				opacity: .3;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
		}
	}
	&.card-carousel-gradient {
		.inside-wrapper {
			&:before {
				animation: rotate-gradient 5s linear infinite;
				background: linear-gradient(135deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
			}
			.wrapper-content {
				.wrapper-heading-card {
					h4 {
						background-image: var(--gradient-prices-green);
						-webkit-background-clip: text;
						-webkit-text-fill-color: rgba(0, 0, 0, 0);
					}
				}
			}
		}
		&:hover {
			.inside-wrapper {
				&:before {
					animation: none;
					opacity: .6;
				}
			}
		}
	}
}
.card-carousel {
	.inside-wrapper {
		border-radius: 28px;
		width: calc(100% - 2px);
		height: calc(100% - 2px);
		position: relative;
		&:before {
			content: '';
			position: absolute;
			top: -9px;
			left: -1px;
			width: calc(100% + 2px);
			height: calc(100% + 10px);
			z-index: -1;
			filter: blur(0);
			opacity: 1;
			transition: all 0.3s ease;
		}
		.wrapper-content {
			.col-6 {
				flex: 0 0 calc(50% - 15px);
				max-width: calc(50% - 15px);
				display: flex;
				flex-direction: column;
				gap: 10px;

				.button {
					width: 100%;
					max-width: 350px;

					a {
						width: 100%;
						box-sizing: border-box;
					}
				}
				.button-read-more {
					cursor: pointer;
					p {
						font-size: 18px;
						line-height: 24px;
						color: var(--color-primary);
						font-weight: 500;
					}
				}
				.wrapper-list {
					border-top: 1px solid var(--color-fill-button);
					.wrapper-price {
						background-color: var(--color-bg);
						display: flex;
						justify-content: center;
						align-items: center;
						height: 50px;
						margin-top: -5px;
						p {
							font-size: 24px;
							line-height: 26px;
							color: var(--color-txt-white);
							margin: 0;
						}
					}
				}
			}
		}
	}
}

.dark .card-carousel {
	.inside-wrapper {
		&:before {
			background: var(--color-txt-white);
		}
		.wrapper-content {

			.wrapper-list {
				.item-list {
					p {
						color: #737f8f;
						&.highlight {
							color: var(--color-txt);
						}
					}
				}
			}
			.button-dark {
				background-color: var(--color-primary);
				span {
					border-radius: 13px;
					background-color: var(--color-primary);
					color: var(--color-txt-white);
				}
				&:hover {
					span {
						background-color: var(--prices-bg-primary-light);
					}
				}
				&.active-plan {
					background: none;
					span {
						color: var(--color-primary);
						background: none;
					}
				}
			}
		}
	}
	&.card-carousel-gradient {
		.inside-wrapper {
			&:before {
				animation: rotate-gradient 5s linear infinite;
				background: linear-gradient(135deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
			}
		}
		&:hover {
			.inside-wrapper {
				&:before {
					background: linear-gradient(135deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
					animation: none;
					opacity: .6;
				}
			}
		}
	}
}

@keyframes rotate-gradient {
	0% {
		background: linear-gradient(0deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	2% {
		background: linear-gradient(7.2deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	4% {
		background: linear-gradient(14.4deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	6% {
		background: linear-gradient(21.6deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	8% {
		background: linear-gradient(28.8deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	10% {
		background: linear-gradient(36deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	12% {
		background: linear-gradient(43.2deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	14% {
		background: linear-gradient(50.4deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	16% {
		background: linear-gradient(57.6deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	18% {
		background: linear-gradient(64.8deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	20% {
		background: linear-gradient(72deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	22% {
		background: linear-gradient(79.2deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	24% {
		background: linear-gradient(86.4deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	26% {
		background: linear-gradient(93.6deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	28% {
		background: linear-gradient(100.8deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	30% {
		background: linear-gradient(108deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	32% {
		background: linear-gradient(115.2deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	34% {
		background: linear-gradient(122.4deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	36% {
		background: linear-gradient(129.6deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	38% {
		background: linear-gradient(136.8deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	40% {
		background: linear-gradient(144deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	42% {
		background: linear-gradient(151.2deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	44% {
		background: linear-gradient(158.4deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	46% {
		background: linear-gradient(165.6deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	48% {
		background: linear-gradient(172.8deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	50% {
		background: linear-gradient(180deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	52% {
		background: linear-gradient(187.2deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	54% {
		background: linear-gradient(194.4deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	56% {
		background: linear-gradient(201.6deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	58% {
		background: linear-gradient(208.8deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	60% {
		background: linear-gradient(216deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	62% {
		background: linear-gradient(223.2deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	64% {
		background: linear-gradient(230.4deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	66% {
		background: linear-gradient(237.6deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	68% {
		background: linear-gradient(244.8deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	70% {
		background: linear-gradient(252deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	72% {
		background: linear-gradient(259.2deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	74% {
		background: linear-gradient(266.4deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	76% {
		background: linear-gradient(273.6deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	78% {
		background: linear-gradient(280.8deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	80% {
		background: linear-gradient(288deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	82% {
		background: linear-gradient(295.2deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	84% {
		background: linear-gradient(302.4deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	86% {
		background: linear-gradient(309.6deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	88% {
		background: linear-gradient(316.8deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	90% {
		background: linear-gradient(324deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	92% {
		background: linear-gradient(331.2deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	94% {
		background: linear-gradient(338.4deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	96% {
		background: linear-gradient(345.6deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	98% {
		background: linear-gradient(352.8deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
	100% {
		background: linear-gradient(360deg, var(--color-prices-green) 0%, var(--color-primary) 100%);
	}
}

</style>